// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3722) return "3722.css";
	if (chunkId === 3524) return "app.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};